var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostponed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8184_21474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58496 14.4159C4.58496 17.1773 6.82354 19.4159 9.58496 19.4159H18.125C20.8864 19.4159 23.125 17.1773 23.125 14.4159V5.87656C23.125 3.11515 20.8864 0.876578 18.125 0.876559L9.58499 0.8765C6.82356 0.87648 4.58496 3.11506 4.58496 5.8765V14.4159Z",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4158 19.4155V19.4155C19.4159 21.4634 17.7558 23.1235 15.708 23.1235H5.87575C3.11433 23.1235 0.87575 20.885 0.87575 18.1235V8.2915C0.87575 6.24363 2.53588 4.5835 4.58376 4.5835V4.5835",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.125 10.146L8.58203 10.146M19.125 10.146L15.3589 6.37991M19.125 10.146L15.3589 13.9121",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8184_21474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostponed);
export default __webpack_public_path__ + "static/media/postponed.6a1f045ecea9bd7933f64719d6466710.svg";
export { ForwardRef as ReactComponent };